import UserEmailConfigurationsContainer from './containers/UserEmailConfigurationsContainer';
export default UserEmailConfigurationsContainer;
